import { render, staticRenderFns } from "./questionItem.vue?vue&type=template&id=7b511fec&scoped=true"
import script from "./questionItem.vue?vue&type=script&lang=js"
export * from "./questionItem.vue?vue&type=script&lang=js"
import style0 from "./questionItem.vue?vue&type=style&index=0&id=7b511fec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b511fec",
  null
  
)

export default component.exports